import {create} from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import {
    type IEnvConfigType,
    LocaleType,
    OverviewInfo,
    ThemeType,
    WalletAssetMergeType,
    WalletConfigType
} from "../types/types";
import {getOverviewInfoApi} from "../api";

interface StoreState {
    appid:string
    token:string
    did:string
    mid:string
    theme:"dark"|"light"
    endpoints:IEnvConfigType['endpoints']

    setAppid: (appid: string) => void;
    setToken: (token: string) => void;
    setDid: (did: string) => void;
    setMid: (mid: string) => void;
    setEndpoints:(endpoints:IEnvConfigType['endpoints'])=>void

    logout: () => void;
    overview:OverviewInfo|null
    setOverview:(overview:OverviewInfo)=>void
    refreshOverview:()=>Promise<void>
    setTheme:(theme:"dark"|"light")=>void

    address:string
    setAddress:(address:string)=>void

    locale:LocaleType,
    setLocale:(locale:LocaleType)=>void

    wallet:WalletConfigType
    setWallet:(wallet:WalletConfigType)=>void

    chainId:number
    setChainId:(chainId:number)=>void

    assets:WalletAssetMergeType[]
    setAssets:(assets:WalletAssetMergeType[])=>void
}

const persistedState = persist<StoreState>(
    set => ({
        appid: '',
        token:'',
        did:'',
        mid:'',
        overview:null,
        theme:'light',
        setOverview:(overview:OverviewInfo)=>set({
            overview,
            address:overview.address,
            did:overview.did,
            mid:overview.mid
        }),
        refreshOverview:async()=>{
            const res = await getOverviewInfoApi()
            if (res.data) {
                set({overview:res.data})
                set({address:res.data.address})
                set({did:res.data.did})
                set({mid:res.data.mid})
            }
        },
        endpoints:{
            back: "https://api.matchid.ai/",
            auth:"https://auth.matchid.ai/"
        },
        setDid: (did: string) => set({ did: did }),
        setToken: (token: string) => set({ token: token }),
        setAppid: (appid: string) => set({ appid: appid }),
        setMid: (mid: string) => set({ mid: mid }),
        logout: () => set({ token: '',did:'',mid:'',address:'',overview:null ,assets:[]}),
        setTheme:(theme:"dark"|"light")=>set({theme}),
        setEndpoints:(endpoints:IEnvConfigType['endpoints'])=>set({endpoints}),

        address:'',
        setAddress:(address:string)=>set({address}),

        locale:'en',
        setLocale:(locale:LocaleType)=>set({locale}),

        wallet:{
            type: "UserPasscode"
        },
        setWallet:(wallet:WalletConfigType)=>set({wallet}),

        chainId:698,
        setChainId:(chainId:number)=>set({chainId}),
        assets:[],
        setAssets:(assets:WalletAssetMergeType[])=>set({assets})


    }),
    { name: 'match-local' }
);

const useLocalStore = create(devtools(persistedState));

export const localStore = useLocalStore;

export default useLocalStore;
